import { Form } from 'antd';
import { Box, Button, Col, Colors, IcDevice, Text } from 'basic-ui-lib';
import InputCentered from 'basic-ui-lib/components/Input/InputCentered';
import dashboardApis from 'modules/dashboard/services/apis';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getMessageError } from 'services/response';
import { setPageLoading } from 'widgets/PageLoading';

interface CreateNewScreenFormProps {
  storeId: string;
  onContinue: () => void;
}

interface CreateNewScreenFormValues {
  screenName: string;
}
const CreateNewScreenForm = ({ storeId, onContinue }: CreateNewScreenFormProps) => {
  const [form] = Form.useForm<CreateNewScreenFormValues>();
  const navigate = useNavigate();
  const handleCreateNewScreen = async (values: CreateNewScreenFormValues) => {
    try {
      setPageLoading(true);

      const res = await dashboardApis.addNewDevice({
        deviceName: values.screenName,
        storeId: storeId || '',
      });

      if (res?.data?.data) {
        onContinue();
        navigate('/screen/create', {
          state: {
            storeId,
            screenName: values.screenName.trim(),
            deviceInfo: {
              id: res.data.data,
            }
          },
        });
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Failed to create new screen.');
    }
    finally {
      setPageLoading(false);
    }
  };
  return (
    <Form form={form} layout='vertical' onFinish={handleCreateNewScreen}>
      <div className='create-new'>
        <Col>
          <Box className='box-icon' backgroundColor={Colors.primary[1]}>
            <IcDevice width={40} height={40} fill={Colors.primary[6]} />
          </Box>
          <Box>
            <Text title_h9 semibold>
              Cloud Based
            </Text>
            <Text body_1 regular color='neutral.text.3'>
              Create and manage a new screen instance directly form your browser.{' '}
            </Text>
          </Box>
        </Col>
        <Box marginTop={16} marginBottom={16}>
          <Form.Item
            name='screenName'
            rules={[{ required: true, message: 'Please enter screen name' }]}
          >
          <InputCentered placeholder='Screen Name' />
          </Form.Item>
        </Box>
        <Button lg type_cancel type='submit'>
          Create New Screen
        </Button>
      </div>
    </Form>
  );
};
export default CreateNewScreenForm;
